export const DAILY_DEPOSIT_FETCHING = 'DAILY_DEPOSIT_FETCHING';
export const DAILY_DEPOSIT_FETCH_ERROR = 'DAILY_DEPOSIT_FETCH_ERROR';
export const DAILY_DEPOSIT_GET_DATA = 'DAILY_DEPOSIT_GET_DATA';
export const DAILY_DEPOSIT_GET_SITES = 'DAILY_DEPOSIT_GET_SITES';
export const DAILY_DEPOSIT_GET_SUMMARIES = 'DAILY_DEPOSIT_GET_SUMMARIES';
export const DAILY_DEPOSIT_CLEAR_STATE = 'DAILY_DEPOSIT_CLEAR_STATE';
export const DAILY_DEPOSIT_GET_WARNINGS = 'DAILY_DEPOSIT_GET_WARNINGS';
export const DAILY_DEPOSIT_GET_REPORT = 'DAILY_DEPOSIT_GET_REPORT';
export const DAILY_DEPOSIT_GET_CHECKS = 'DAILY_DEPOSIT_GET_CHECKS';
export const DAILY_DEPOSIT_SAVE_SUCCESS = 'DAILY_DEPOSIT_SAVE_SUCCESS';
export const DAILY_DEPOSIT_SET_SAVE_SUCCESSFUL =
  'DAILY_DEPOSIT_SET_SAVE_SUCCESSFUL';
export const DAILY_DEPOSIT_SET_CLOSE_SUCCESSFUL =
  'DAILY_DEPOSIT_SET_CLOSE_SUCCESSFUL';



// WEBPACK FOOTER //
// ./src/pages/dailydeposit/state/dailydeposit/types.js